import React from 'react';

import Illustration from './Illustration';

export default function Avatar({ avatar, isLarge }) {
  const style = `avatar ${isLarge ? '--large' : ''}`;
  return (
    <div className={style}>
      <Illustration illustration={avatar} />
    </div>
  );
}
